import { render, staticRenderFns } from "./AdminWorkspacePopup.vue?vue&type=template&id=672c185a&scoped=true&"
import script from "./AdminWorkspacePopup.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspacePopup.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkspacePopup.vue?vue&type=style&index=0&id=672c185a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c185a",
  null
  
)

export default component.exports